import axios from "axios";
import * as qs from "qs";
import {
  API_BASE_URL,
  API_KEY,
  imgUrl,
  apiUrlWithKey,
  baseURLModel,
  baseURLFabrics,
  baseURLGetRail,
  baseURLPrice,
  baseURLZipCode,
  baseURLFreeShipping,
  ProductGroupSetPageName,
  baseURLGetProductGroup,
  baseURLGetProductGroupPage,
  baseURGetProject,
  baseURLGetCart,
  baseURLUploadImg,
  baseURLUploadPdf,
  baseURLDeleteFile,
  baseURLDeleteBasketProject,
  baseURLGetRemoteNames,
  baseURLGetProjects,
  baseURLEditProject,
  baseURLCats as _baseURLCats,
  baseURLCatProduct2 as _baseURLCatProduct2,
  baseURLDeleteSewingProject,
} from "../config/api";

export {
  API_BASE_URL,
  API_KEY,
  imgUrl,
  apiUrlWithKey,
  baseURLModel,
  baseURLFabrics,
  baseURLGetRail,
  baseURLPrice,
  baseURLZipCode,
  baseURLFreeShipping,
  ProductGroupSetPageName,
  baseURLGetProductGroup,
  baseURLGetProductGroupPage,
  baseURGetProject,
  baseURLGetCart,
  baseURLUploadImg,
  baseURLUploadPdf,
  baseURLDeleteFile,
  baseURLDeleteBasketProject,
  baseURLGetRemoteNames,
  baseURLGetProjects,
  baseURLEditProject,
};

export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const baseUrlCats = _baseURLCats;
export const baseUrlCatProduct = _baseURLCatProduct2;
export const baseURLDeleteProject = baseURLDeleteSewingProject;

/**
 * @param {string} catID
 * @returns {Promise}
 */
export const getCats = (catID) => axios.get(_baseURLCats, { params: { pageName: catID } });
export const getCatProduct = (paramObj) =>
  axios.get(_baseURLCatProduct2, {
    params: paramObj,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
